import React from "react";
import { Input as InputLib, FormGroup } from "reactstrap";

function Input(props) {
  return (
    <FormGroup>
      <InputLib
        type={props.type}
        name={props.name}
        onChange={props.onChange}
        placeholder={props.placeholder}
        value={props.value}
        invalid={!!props.errorMessage}
      />
    </FormGroup>
  );
}

Input.defaultProps = {
  type: "text"
};

export default Input;
